/**
 * Sets up a click event and keyboard accessibility for menu trigger
 */
export function setup_menu_trigger()
{
	const menuTrigger = $('.menu-trigger');
	const popupMenu = $('.popup-menu');
	const body = $('body');
	
	// Click handler
	menuTrigger.click(function (e){
		e.preventDefault();
		toggleMenu();
	});
	
	// Keyboard handler for menu trigger
	menuTrigger.keydown(function(e) {
		// Space (32) or Enter (13) key
		if (e.keyCode === 32 || e.keyCode === 13) {
			e.preventDefault();
			toggleMenu();
		}
	});
	
	// Escape key handler for closing menu when focus is within menu
	$(document).keydown(function(e) {
		if (e.keyCode === 27) { // Escape key
			const isMenuOpen = body.hasClass('menu-active');
			const focusWithinMenu = popupMenu.find(':focus').length > 0;
			
			if (isMenuOpen && (focusWithinMenu || document.activeElement === menuTrigger[0])) {
				closeMenu();
				menuTrigger.focus(); // Return focus to hamburger button
			}
		}
	});
	
	// Focus trap handler
	$(document).keydown(function(e) {
		if (e.keyCode === 9 && body.hasClass('menu-active')) { // Tab key when menu is open
			trapFocus(e, popupMenu, menuTrigger);
		}
	});
	
	function toggleMenu() {
		if (body.hasClass('menu-active')) {
			closeMenu();
		} else {
			openMenu();
		}
	}
	
	function openMenu() {
		body.addClass('menu-active');
		
		// Update ARIA attributes
		menuTrigger.attr('aria-expanded', 'true');
		menuTrigger.attr('aria-label', 'Close navigation menu');
		popupMenu.attr('aria-hidden', 'false');
		
		// Show menu visually
		popupMenu.show();
		
		// Remove tabindex from menu items
		popupMenu.find('a, button').removeAttr('tabindex');
		
		// Move focus to first menu item if opened via keyboard
		if (document.activeElement === menuTrigger[0]) {
			const firstMenuItem = popupMenu.find('a, button').first();
			if (firstMenuItem.length) {
				firstMenuItem.focus();
			}
		}
		
		// Handle submenu show/hide
		$('.menu-showhide__trigger').removeClass('active');
		$('.menu-showhide__body').slideUp(600);

		// close the menu if the link clicked goes to the current page
		$('li.menu-item a').each(function() {
			if (this.href === window.location.href) {
				$(this).on('click', closeMenu);
			}
		});
	}
	
	function closeMenu() {
		body.removeClass('menu-active');
		
		// Update ARIA attributes
		menuTrigger.attr('aria-expanded', 'false');
		menuTrigger.attr('aria-label', 'Open navigation menu');
		popupMenu.attr('aria-hidden', 'true');
		
		// Hide menu visually
		popupMenu.hide();
		
		// Set tabindex="-1" on menu items when closed
		popupMenu.find('a, button').attr('tabindex', '-1');
		
		// Handle submenu show/hide
		$('.menu-showhide__trigger').removeClass('active');
		$('.menu-showhide__body').slideUp(600);
	}
	
	/**
	 * Trap focus within the menu when it's open
	 */
	function trapFocus(e, menuContainer, menuTrigger) {
		// Get all focusable elements within the menu + the menu trigger
		const focusableElements = menuContainer.find('a, button, [tabindex]:not([tabindex="-1"])').add(menuTrigger);
		const firstElement = focusableElements.first();
		const lastElement = focusableElements.last();
		
		// If shift+tab on first element, go to last element
		if (e.shiftKey && document.activeElement === firstElement[0]) {
			e.preventDefault();
			lastElement.focus();
		}
		// If tab on last element, go to first element
		else if (!e.shiftKey && document.activeElement === lastElement[0]) {
			e.preventDefault();
			firstElement.focus();
		}
		// If focus is not within our focusable elements, move to first element
		else if (focusableElements.index(document.activeElement) === -1) {
			e.preventDefault();
			firstElement.focus();
		}
	}
}

/**
 * Updates the menu based on the current url
 */
export function update_menu()
{
	//Update the menu aria-current page based on urls
	let url = window.location.href;

	//Remove the old current page attributes
	let current_page = $('.nav li.current-menu-item');
	current_page.removeClass('current-menu-item').find('a').attr('aria-current', '');

	//Find the new current page and add classes
	let active_items = $('.nav').find('a[href="' + url + '"]');
	active_items.each(function(){
		$(this).attr('aria-current', 'page');
		$(this).parent().addClass('current-menu-item');
	});
}

export function menu_showhide()
{
	$('.menu-showhide__trigger').on('click', function() {
		console.log('test');

		let parent = $(this).parent();
		let body = parent.find('.menu-showhide__body');
		let trigger = $(this);

		if( trigger.hasClass('active') )
		{
			trigger.removeClass('active');
			trigger.attr('aria-expanded', 'false');
			body.slideUp(600);
			body.attr('aria-hidden', 'true');
		}
		else
		{
			trigger.addClass('active');
			trigger.attr('aria-expanded', 'true');
			body.slideDown(600);
			body.attr('aria-hidden', 'false');
		}
	});
	
	// Add keyboard support for submenu triggers
	$('.menu-showhide__trigger').keydown(function(e) {
		if (e.keyCode === 32 || e.keyCode === 13) { // Space or Enter
			e.preventDefault();
			$(this).click();
		}
	});
}

/**
 * Initialize menu accessibility on page load
 */
export function init_menu_accessibility() {
	// Set initial tabindex on menu items when page loads
	const popupMenu = $('.popup-menu');
	const body = $('body');
	
	if (!body.hasClass('menu-active')) {
		popupMenu.find('a, button').attr('tabindex', '-1');
	}
	
	// Add ARIA attributes to submenu triggers
	$('.menu-showhide__trigger').each(function() {
		const trigger = $(this);
		const body = trigger.parent().find('.menu-showhide__body');
		
		// Add ARIA attributes
		trigger.attr('aria-expanded', 'false');
		if (!trigger.attr('id')) {
			trigger.attr('id', 'submenu-trigger-' + Math.random().toString(36).substr(2, 9));
		}
		
		const triggerId = trigger.attr('id');
		body.attr('aria-labelledby', triggerId);
		body.attr('aria-hidden', 'true');
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js